<script setup lang="ts">
import { Divisible } from '@precon-tools-suite-by-shared/vue-divisibles';
import Message from 'primevue/message';
import Button from 'primevue/button';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        error?: unknown;
        /**
         * Fallback title for the error.
         */
        errorMessage?: string;
        errorTitle?: string;
        errorName?: string;
        errorAction?: string;
        closable?: boolean;
    }>(),
    {
        errorTitle: undefined,
        errorMessage: undefined,
        errorName: undefined,
        errorAction: undefined,
        error: () => {
            return new Error('No error provided for ErrorPartial.');
        },
    }
);

const title = computed<string | null>(() => {
    return props.errorTitle ?? 'Oeps, daar ging iets mis...';
});

const name = computed<string>(() => {
    if (props.errorName) return props.errorName;
    if (props.error instanceof Error) {
        return props.error.constructor.name;
    }
    return 'Error';
});

const message = computed<string>(() => {
    return props.errorMessage ?? '[hidden]';
});

const action = computed<string | null>(() => {
    return props.errorAction ?? null;
});

const logError = () => {
    console.info(
        '%c%s%c\n\n Javacript Object:%O\n Error stack-trace:\n%o',
        'font-weight:bold;font-size:large;color:#F00',
        title.value,
        'font-weight:bold',
        props.error,
        props.error
    );
};
</script>

<template>
    <Divisible target="tools" observed-only>
        <template #default="slot">
            <Button
                icon="pi pi-code"
                class="p-button-secondary p-button-text p-button-rounded"
                :class="slot['button-class']"
                @click="logError"
            />
        </template>
    </Divisible>

    <Message
        severity="error"
        class="dynamic-error-message--full-text"
        :closable="closable ?? false"
        v-bind="$attrs"
    >
        <Divisible is="h5" target="title" class="mb-0">
            {{ title }}
        </Divisible>

        <div>
            <span class="font-bold">{{ name }}:</span>
            {{ message }}
        </div>

        <div v-if="action !== null">
            {{ action }}
        </div>
    </Message>
</template>

<style>
.dynamic-error-message--full-text .p-message-text {
    width: 100%;
}
</style>
